import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

export default function CancelMenuLayoutDialog(props) {
  const { onCancel, onOk } = props;

  return (
    <Dialog closeIcon={false} width={350} title={"Changes Made"}>
      <p style={{ margin: "25px", textAlign: "center" }}>
        Changes have been made
        <br />
        Exit without saving?
      </p>
      <DialogActionsBar>
        <button
          aria-label="ok button of warning dialog"
          className="k-button k-button-primary"
          onClick={onOk}
        >
          Ok
        </button>
        <button
          aria-label="cancel button of warning dialog"
          className="k-button"
          onClick={onCancel}
        >
          Cancel
        </button>
      </DialogActionsBar>
    </Dialog>
  );
}
